/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { LoginWrapper } from '@components/login/LoginContext';
import { createStaticApolloClient } from '@graphql/server';
import { withAuth } from '@hocs/withAuth';
import { getDefaultProps } from '@utils/pages';
import { GetStaticPropsContext, GetStaticPropsResult, NextPage } from 'next';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { NextSeo } from 'next-seo';
import dynamic from 'next/dynamic';

const LoginView = dynamic(() => import('@components/login/LoginView'));

type LoginPageProps = object;

const LoginPage: NextPage<LoginPageProps> = () => {
  const { t } = useTranslation();

  return (
    <>
      {/* SEO metadata */}
      <NextSeo title={t('INICIAR_SESION')} />

      <LoginWrapper>
        <LoginView />
      </LoginWrapper>
    </>
  );
};

export const getStaticProps = async (
  ctx: GetStaticPropsContext,
): Promise<GetStaticPropsResult<LoginPageProps>> => {
  const client: ApolloClient<NormalizedCacheObject> = await createStaticApolloClient();

  return {
    props: {
      ...(await getDefaultProps({ locale: ctx.locale, client })),
      ...(await serverSideTranslations(ctx.locale, ['common'])),
    },
  };
};

export default withAuth(LoginPage, { shouldBeLoggedIn: false });
